{
  "tema": null,
  "logo": null
}
